export default __webpack_public_path__ + "static/media/warning--junction-with-a-side-road-perpendicular-left--g1.9d8f0946.png";